import { render, staticRenderFns } from "./CPanelSettings.vue?vue&type=template&id=a572409e&scoped=true&"
import script from "./CPanelSettings.vue?vue&type=script&lang=js&"
export * from "./CPanelSettings.vue?vue&type=script&lang=js&"
import style0 from "./CPanelSettings.vue?vue&type=style&index=0&id=a572409e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a572409e",
  null
  
)

export default component.exports